import type { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import {
    MIN_RECURRENCE_INTERVAL,
    MAX_RECURRENCE_INTERVAL,
} from 'owa-recurrence-utils/lib/constants';

export default function getIntervalNumericMenuItems(): IDropdownOption[] {
    let intervalItems = [];
    for (let num = MIN_RECURRENCE_INTERVAL; num <= MAX_RECURRENCE_INTERVAL; num++) {
        intervalItems.push({
            key: num,
            text: num.toString(),
        });
    }
    return intervalItems;
}
